import { andComp, anyComp, codeIs, entityIs } from '@bingads-webui-campaign-react/form-error';

export const NCA_STRATEGY_OPTIONS = {
  BID_HIGHER: 'BidHigher',
  BID_ONLY: 'BidOnly',
};

export const ADDITIONAL_CONVERSION_VALUE_TYPES = {
  CAMPAIGN: 'Campaign',
  ACCOUNT: 'Account',
};

const ERROR_ENTITY = {
  Campaign: 'campaign',
};

export const newCustomerAcquisitionServerErrorFilter = andComp(
  entityIs(ERROR_ENTITY.Campaign),
  anyComp(
    codeIs('InvalidBidStrategyForNewCustomerAcquisitionBidHigherMode'),
    codeIs('InvalidNewCustomerAcquisitionGoalId'),
    codeIs('PurchaseCampaignConversionGoalOnlyForNcaEnabledCampaign'),
    codeIs('InvalidAdditionalConversionValue'),
    codeIs('AudienceAssociationRequiredForNewCustomerAcquisitionGoal'),
    codeIs('CampaignLevelAdditionalValueNotSupportedForBidOnlyMode')
  )
);
